(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tf-stats"] && !Shopify.designMode) return;
  try {
    
(function() {
  function animateCounter(el) {
    const raw = el.dataset.count;
    const target = parseInt(raw, 10);
    if (Number.isNaN(target)) return;

    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    const duration = 2000;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * target);
      el.textContent = prefix + current + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  document.querySelectorAll('[data-tf-stats]').forEach(function(section) {
    const observer = new IntersectionObserver(function(entries) {
      if (!entries[0].isIntersecting) return;
      section.classList.add('tf-stats--visible');
      section.querySelectorAll('[data-count]').forEach(animateCounter);
      observer.disconnect();
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    observer.observe(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
